export type ManualRecapGenerationResult = {
  created: string | null;
  provider: string;
  reason?: string;
};

export type ManualRecapGenerationFeedback = {
  kind: "success" | "info" | "error";
  message: string;
};

export function describeManualRecapGenerationResult(
  result: ManualRecapGenerationResult,
): ManualRecapGenerationFeedback {
  if (result.created) {
    return { kind: "success", message: "Summary generated." };
  }

  switch (result.reason) {
    case "provider_error":
      return {
        kind: "error",
        message: "Summary generation failed: provider returned invalid output.",
      };
    case "missing_api_key":
      return {
        kind: "error",
        message: "Summary generation failed: provider API key is not configured.",
      };
    case "no_recap_window":
      return {
        kind: "info",
        message: "No missing transcript window to summarize.",
      };
    case "repairing_suffix":
      return {
        kind: "info",
        message: "Transcript edits are still repairing summaries. Try again after repair finishes.",
      };
    case "ongoing_empty_cooldown":
      return {
        kind: "info",
        message: "No summary was generated because the latest open segment was empty.",
      };
    case "no_active_session":
      return {
        kind: "error",
        message: "Summary generation failed: no active session was found.",
      };
    case "empty":
      return {
        kind: "info",
        message: "No substantive summary content was generated.",
      };
    default:
      return {
        kind: result.reason ? "error" : "info",
        message: result.reason
          ? `Summary generation finished without creating a recap: ${formatReason(result.reason)}.`
          : "Summary generation finished without creating a recap.",
      };
  }
}

function formatReason(reason: string): string {
  return reason.replace(/_/g, " ");
}
